"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _ListingImageV = _interopRequireDefault(require("../elements-image/ListingImageV2"));
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ActivityTileSearch = function ActivityTileSearch(_ref) {
  var activities = _ref.activities,
    _ref$urlPrefix = _ref.urlPrefix,
    urlPrefix = _ref$urlPrefix === void 0 ? '' : _ref$urlPrefix;
  var items = (0, _lodash.get)(activities, 'items', []);
  var ulrPrefixLink = urlPrefix ? "/".concat(urlPrefix) : '';
  var placeholderImage = /*#__PURE__*/_react.default.createElement("img", {
    src: "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ActivitySection container"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "h4"
  }, (0, _lodash.get)(activities, 'sectionTitle')), /*#__PURE__*/_react.default.createElement("div", {
    className: "row thumbnail-container"
  }, (0, _lodash.map)(items, function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: item.contentLinkUrl,
      className: "col-xs-6 col-sm-3 thumbnail-col"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "".concat(ulrPrefixLink).concat(item.contentLinkUrl)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "thumbnail marketing",
      "data-activity": item.contentTitle
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hover-wrapper"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "img-container"
    }, /*#__PURE__*/_react.default.createElement(_reactLazyload.default, {
      offset: 100,
      placeholder: placeholderImage,
      once: true
    }, /*#__PURE__*/_react.default.createElement(_ListingImageV.default, {
      sizes: "300px",
      imgId: item.contentCloudinaryId,
      alt: item.imageAltText,
      ratio: 1,
      widths: [500],
      className: "img-rounded"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "caption"
    }, /*#__PURE__*/_react.default.createElement("h4", {
      className: "title ellipsis capitalize-first-letter text-center activity-header block-xs-center"
    }, item.contentTitle)))));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(ulrPrefixLink).concat((0, _lodash.get)(activities, 'sectionLinkUrl'))
  }, (0, _lodash.get)(activities, 'sectionLinkText'), /*#__PURE__*/_react.default.createElement("i", {
    className: "ico ico-sm icon-arrow-nav"
  })))));
};
ActivityTileSearch.propTypes = {
  activities: _propTypes.default.object,
  urlPrefix: _propTypes.default.string
};
var _default = exports.default = ActivityTileSearch;